"use client";

import { useSpotifyWebPlayer } from "@/hooks/useSpotifyWebPlayer";
import { isMp3OnlyMode } from "@/lib/mp3OnlyMode";

function SpotifyPlayerBootstrap() {
  useSpotifyWebPlayer({
    autoTransfer: false,
    autoTransferPlay: false,
  });

  return null;
}

/**
 * Prewarms provider-specific playback infrastructure that benefits from
 * app-wide startup. Spotify needs its Web Playback SDK device registered
 * before the session UI asks for transport controls.
 */
export default function MediaPlayerBootstrap() {
  if (isMp3OnlyMode) {
    return null;
  }

  return <SpotifyPlayerBootstrap />;
}
